module.exports = __webpack_public_path__ + "img/14_maska_shesterenka.4178281.svg";